import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    company: "",
    branch: ""
};
export const location = createSlice({
    name: "location",
    initialState: initialState,
    reducers: {
        changeLocation: (state, action) => {
            if (action.payload.company) {
                state.company = action.payload.company;
            }
            if (action.payload.branch) {
                state.branch = action.payload.branch;
            }
        }
    }
})

export const { changeLocation } = location.actions;
export default location.reducer;